var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"list":_vm.list}),(_vm.total>0&&(_vm.total>_vm.limit||_vm.alwaysShowPager))?_c('el-pagination',{staticClass:"pager",attrs:{"background":"","layout":"prev, pager, next","total":_vm.total},on:{"current-change":_vm.changePage}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }